
    const path = "/LSMSAppPortal/config.js";
    const script = document.createElement('script');
    script.type= "text/javascript";
    script.src = path;
    script.onload= () => {
        console.log("LSMSAppPortal config is loaded");
    }
    document.head.appendChild(script);
// }

const path2 = "/LSMSAppPortal/DragDropTouch.js";
    const script2 = document.createElement('script');
    script2.type= "text/javascript";
    script2.src = path2;
    script2.onload= () => {
        console.log("LSMSAppPortal config is loaded");
    }
    document.head.appendChild(script2);


export const loadConfig= "none"